import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerB');

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751855303099/BannerB-pc.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1751855312491/BannerB-h5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751855312491/BannerB-h5.jpg',
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
            <div className="text-container">
                <h2>{t('title')}</h2>
                <h3>{t(`sub_title`)}</h3>
            </div>
        </div>
    );
}
